import React from 'react'

function BreadCrumbs({title}) {
    return (
        <section className="content-header">
            <h3 className="mb-3"> </h3>
            <ol className="breadcrumb">
                <li><a href="dashboard"><i className="fa fa-dashboard"></i> Home</a></li>
                <li className="active">{title}</li>
            </ol>
        </section>
    )
}

export default BreadCrumbs